import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { authData } from "src/app/util/auth";

@Component({
  selector: "app-application-new",
  templateUrl: "./application-new.component.html",
})
export class ApplicationNewComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}
  applicationType = "";
  semester = "";
  applicationTypes: any = [];
  notification: any = {};

  loading = false;
  skeletonLoader = true;
  downloader: any = null;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.getApplictionTypes();
  }

  getApplictionTypes() {
    this.notification = {};
    this.loading = true;
    const baseUrl = `${environment.BASE_URL}/applications/applicationtypes`;
    this.httpClient
      .get(baseUrl, this.httpOptions)
      .subscribe({
        next: (res: any) => {
          this.applicationTypes = res?.Data;
          this.loading = false;
          this.skeletonLoader = false;
        },
        error: (err) => {
          this.loading = false;
          this.notification = {
            error: true,
            message:
              err?.Message ||
              err?.error?.Message ||
              "An error occurred. Try again",
          };
        },
      });
  }

  submitApplication() {

    this.loading = true;
    this.notification = {};

    this.downloader = {
      loading: true,
    };

    const baseUrl = `${environment.BASE_URL}/applications/GenerateApplicationReference?applicationType=${this.applicationType}`;
    this.httpClient.post(baseUrl, {}, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          // this.downloader = {
          //   loading: false,
          //   name: res.Data.Name,
          //   url: `data:application/octet-stream;base64,${res.Data.Data}`,
          // };
          this.loading = false;
          this.notification = {
            error: false,
            message:
              "Application submitted successfully",
          };
          this.continueApplication();
        }
        else {
          this.downloader = null;
        }
      },
      error: (err) => {
        this.downloader = null;
        this.notification = errorHandler(err);
      },
      complete: () => {
        this.skeletonLoader = false;
      },
    });
  }

  continueApplication() {
    var baseUrl = `${environment.BASE_URL}/applications/PortalLogin`;

    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.downloader = null;
          window.open(res.Data, "_blank");
        } else {
          this.router.navigateByUrl(`/#${res.Message}`);
        }
      },
      error: (err: any) => {
        this.router.navigateByUrl(`/#${err.error.Message}`);
      },
    });

  }

  downloadFile(res: any) {
    var file_path = `data:application/octet-stream;base64,${res.Data.Data}`;
    var downloader = document.createElement('A');
    downloader.setAttribute("href", file_path.toString());
    downloader.setAttribute("download", res.Data.Name);
    document.body.appendChild(downloader);
    downloader.click();
    document.body.removeChild(downloader);
  }
}
